module.exports = __webpack_public_path__ + "img/teacher.7e060091.png";